import { breakpoints } from "../tokens/size";
import { v2Colors } from "../tokens/color";
import { buttonBaseStyles, getFocusStyles, getVariantStyles, sizeStyles, getWidthStyles, } from "../components/V2Button/styles";
/**
 * @deprecated Use the V2Button component instead.
 */
export const buttonStyles = {
    errorOutlined: {
        padding: '1rem 1.4rem !important',
        backgroundColor: v2Colors.background.white,
        color: v2Colors.action.ember,
        border: '0.1rem solid',
        borderColor: v2Colors.action.ember,
        fontSize: '1.4rem',
        '& svg': {
            marginLeft: '1rem',
            color: v2Colors.action.ember,
        },
        '&:hover': {
            color: v2Colors.text.inversePrimary,
            borderColor: v2Colors.action.ember,
            backgroundColor: v2Colors.action.ember,
        },
        '&:hover svg': {
            color: v2Colors.text.inversePrimary,
        },
        '@media (prefers-reduced-motion: reduce)': {
            '&:focus': {
                color: v2Colors.action.ember,
                borderColor: v2Colors.action.ember,
                backgroundColor: v2Colors.action.ember,
            },
            '&:focus svg': {
                color: v2Colors.text.inversePrimary,
            },
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            textAlign: 'center',
        },
    },
};
export const v2ButtonStyles = ({ variant, color = 'blue', size = 'medium', fullWidth = false, isSelected = false, }) => {
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, buttonBaseStyles), getFocusStyles(color, variant)), getWidthStyles(fullWidth)), sizeStyles[size]), getVariantStyles(variant, color, isSelected));
};
